import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams, } from "react-router-dom";

import {
  get_problema_thread, post_letto_thread
} from '../api';
import {
  Problema, NuovoCommento, LoadingCircle,
} from '../components';
import { login_url } from '../globals'
import { useLogin, useThread } from '../reducers';
import { emptyFeed, fetchFeed, renderFeed } from '../utils/feed';


type Thread = Awaited<ReturnType<typeof get_problema_thread>>;

const filterFactory = (thread: Thread) => {
  return {
    commenti: { thread: thread.id },
    commenti_shortlist: { thread: thread.id },
    risposte: { problema: thread.problema.id },
    assegnazione: { problema: thread.problema.id },
    modifiche_commenti: { commento__thread: thread.id },
    modifiche_problemi: { thread: thread.id },
    citazioni: { thread: thread.id },
  }
}



const ThreadProblema = (props: {}) => {
  const login = useLogin()
  const [thread, setThread] = useState<Thread | null>(null)
  const threads = useThread(props);
  const [commentFocusRequest, setCommentFocusRequest] = useState(0);
  const commentEditor = useRef<HTMLDivElement>(null);
  const [feed, setFeed] = useState(emptyFeed)
  const params = useParams<{ pk: string }>()

  const pk = parseInt(params.pk as string);

  useEffect(() => {
    get_problema_thread(pk).then(thread => {
      setThread(thread)
      fetchFeed(filterFactory(thread)).then(setFeed)
    })
    post_letto_thread(pk);
  }, [pk])

  useEffect(() => {
    if (!thread) {
      document.title = `#${pk} - Owlitrack`;
    } else {
      document.title = `${thread.titolo}`;
    }
  }, [thread])

  useEffect(() => {
    if (commentFocusRequest === 0) return;
    const textarea = commentEditor.current?.querySelector('textarea');
    textarea?.focus({ preventScroll: true });
    textarea?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [commentFocusRequest]);

  if (!login.logged_in) {
    login_url()
  }
  if (!thread) {
    return (
      <LoadingCircle />
    );
  }

  const rendered_feed = renderFeed(feed, threads, prob => prob.id === pk, true, true);
  const actions = (
    <div className="d-flex flex-wrap align-items-center my-3" role="group" aria-label="Partecipa al thread">
      <button type="button" className="btn btn-primary mr-2 my-1"
        aria-controls="nuovo-commento" aria-expanded={commentFocusRequest > 0}
        onClick={() => setCommentFocusRequest(request => request + 1)}>
        <i className="fa fa-comment-dots mr-1" aria-hidden="true" /> Commenta
      </button>
      <Link className="btn btn-success my-1" to={`/thread/problema/${pk}/rispondi/`}>
        <i className="fa fa-reply mr-1" aria-hidden="true" /> Consegna risposta
      </Link>
    </div>
  );
  return (
    <div className="container-fluid mb-4">
      <Problema thread={thread} pageHeading />
      {actions}
      <section className="mt-4 pt-4 border-top" aria-labelledby="thread-discussion-title">
        <h2 id="thread-discussion-title" className="h4 mb-3">Discussione e attività</h2>
        {rendered_feed}
        {actions}
        {commentFocusRequest > 0 && (
          <div id="nuovo-commento" ref={commentEditor} className="mt-3">
            <NuovoCommento thread={pk} />
          </div>
        )}
      </section>
    </div>
  );
}


export default ThreadProblema;
